module.exports = __webpack_public_path__ + "static/img/20.3577aac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/sp/20.png
// module id = oXWj
// module chunks = 0